<!--
    EiToolingRawDataTabComponent Template

    Pretty-printed JSON with copy/download actions.
-->

<div class="flex align-items-center justify-content-between mb-2">
    <h6 class="m-0">Rohdaten des Datensatzes</h6>
    <div class="flex gap-2">
        <p-button
                icon="fa-regular fa-copy"
                [text]="true"
                [rounded]="true"
                severity="secondary"
                pTooltip="In Zwischenablage kopieren"
                [disabled]="!hasData"
                (onClick)="copyToClipboard()">
        </p-button>
        <p-button
                icon="fa-regular fa-download"
                [text]="true"
                [rounded]="true"
                severity="secondary"
                pTooltip="Herunterladen"
                [disabled]="!hasData"
                (onClick)="downloadJson()">
        </p-button>
    </div>
</div>

@if (hasData) {
    <pre class="ei-tooling-raw-data surface-100 border-round p-3 overflow-auto"><code>{{ formattedJson }}</code></pre>
} @else {
    <p-message
            severity="info"
            text="Keine Rohdaten für diesen Datensatz vorhanden."
            [closable]="false">
    </p-message>
}
